import { inject, singleton } from 'tsyringe';
import { IShellDAO } from '../../dao/IShellDAO';
import { UserDataType } from './types';
import ShellLocalStorageDAOImpl from '../../dao/ShellLocalStorageDAOImpl';

@singleton()
class UserDataRepository {
  private shellDAO: IShellDAO;
  private prefixKey = 'jshellUserData';

  constructor(
    @inject(ShellLocalStorageDAOImpl)
    shellLocalStorageDAOImpl: ShellLocalStorageDAOImpl
  ) {
    this.shellDAO = shellLocalStorageDAOImpl;
  }

  save(userData: UserDataType): void {
    this.shellDAO.save(this.prefixKey, userData);
  }

  findOne(): UserDataType {
    return this.shellDAO.findOne(this.prefixKey);
  }

  delete(): boolean {
    return this.shellDAO.delete(this.prefixKey);
  }

  clear(): void {
    this.delete();
  }
}

export default UserDataRepository;
